// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_components__CountryIcon from "../../../../../../packages/components/src/atoms/CountryIcon.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__Field from "../../../components/landing/Field.js";
import * as Buhta_landing__FooterUtils from "./FooterUtils.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Cms from "../../../../../../packages/models/Cms.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FooterForm(Props) {
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setCompany = match$1[1];
  const company = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setEmail = match$2[1];
  const email = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setPhone = match$3[1];
  const phone = match$3[0];
  const match$4 = React.useState(function () {
    return true;
  });
  const setPhoneValid = match$4[1];
  const match$5 = React.useState(function () {
    return false;
  });
  const setLoading = match$5[1];
  const loading = match$5[0];
  const dropdownRef = React.useRef(null);
  const match$6 = React.useState(function () {
    return false;
  });
  const setDropdownShown = match$6[1];
  const dropdownShown = match$6[0];
  const phoneInputRef = React.useRef(null);
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const prefix = Buhta_models__Locale.getPhonePrefix(country);
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: Buhta_landing__I18n.trans(intl, "company_name"),
        type_: "text",
        name: "company",
        value: company,
        onChange: (function (value) {
          Curry._1(setCompany, (function (param) {
            return value;
          }));
        }),
        className: "h-13 w-65 border-t border-b border-l border-divider first:rounded-bl-lg first:rounded-tl-lg px-4 py-1.5",
        required: true,
        disabled: loading
      }),
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Email",
        type_: "email",
        name: "email",
        value: email,
        onChange: (function (value) {
          Curry._1(setEmail, (function (param) {
            return value;
          }));
        }),
        className: "h-13 w-65 border-t border-b border-l border-divider first:rounded-bl-lg first:rounded-tl-lg px-4 py-1.5",
        required: true,
        disabled: loading
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__CountryIcon.make, {
            country: country
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("span", {
                children: prefix,
                className: "paragraph-medium text-black-landing ml-3"
              }),
              JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/dropdown-arrow.svg")
              })
            ],
            className: "flex cursor-pointer",
            onClick: (function (param) {
              Curry._1(setDropdownShown, (function (param) {
                return !dropdownShown;
              }));
            })
          }),
          JsxRuntime.jsx("div", {
            ref: dropdownRef,
            children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, c) {
              const Key = "country_dropdown_" + String(index);
              return JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: c.code,
                  _1: language,
                  _2: /* Home */ 0
                },
                className: "paragraph-small text-black-landing py-2 px-4 block cursor-pointer transition-all duration-200 ease-in-out hover:bg-bg",
                onLinkClicked: (function (param) {
                  Curry._1(setDropdownShown, (function (param) {
                    return false;
                  }));
                }),
                children: [
                  c.icon,
                  Buhta_models__Locale.getPhonePrefix(c.code)
                ]
              }, Key);
            }), Buhta_landing__FooterUtils.countries)),
            className: Cn.fromList({
              hd: "absolute top-11 left-0 w-40 bg-white shadow-dropdown rounded-md py-4",
              tl: {
                hd: dropdownShown ? "block" : "hidden",
                tl: /* [] */ 0
              }
            })
          }),
          JsxRuntime.jsx("input", {
            ref: phoneInputRef,
            className: Cn.fromList({
              hd: "paragraph bg-bg w-35.25 input-invalid",
              tl: {
                hd: match$4[0] ? "text-black-landing" : "text-alert",
                tl: /* [] */ 0
              }
            }),
            disabled: loading,
            name: "phone",
            type: "text",
            value: phone,
            onChange: (function (ev) {
              const value = ev.target.value;
              Curry._1(setPhone, (function (param) {
                return value;
              }));
              Curry._1(setPhoneValid, (function (param) {
                return Buhta_landing__FooterUtils.checkPhoneValid(phoneInputRef, country);
              }));
            })
          })
        ],
        className: "relative w-65 border-t border-b border-l border-divider flex items-center pl-4",
        onClick: (function (param) {
          Buhta_landing__EventHandlers.focusInput(phoneInputRef);
        })
      }),
      JsxRuntime.jsx("input", {
        className: "paragraph-medium text-white bg-primary w-57 cursor-pointer rounded-br-lg rounded-tr-lg transition-all duration-200 ease-in-out hover:bg-primary-hover active:bg-primary-active disabled:opacity-64",
        disabled: loading,
        type: "submit",
        value: Buhta_landing__I18n.trans(intl, "send_request")
      })
    ],
    className: "flex m-auto mt-10 justify-between lg:w-252",
    onSubmit: (function (ev) {
      const payload = {
        company: company,
        email: email,
        phone: phone,
        prefix: prefix,
        serviceType: "",
        name: "",
        bin: "",
        question: ""
      };
      Curry._1(setLoading, (function (param) {
        return true;
      }));
      ev.preventDefault();
      const __x = Buhta_landing__Api.submitRequest(Buhta_models__Cms.$$Request.encode(payload));
      $$Promise.get(__x, (function (res) {
        if (res.TAG === /* Ok */ 0) {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Заявка успешно доставлена",
              kind: "success",
              onClick: (function (param) {
                
              })
            }
          });
          Curry._1(setCompany, (function (param) {
            return "";
          }));
          Curry._1(setEmail, (function (param) {
            return "";
          }));
          Curry._1(setPhone, (function (param) {
            return "";
          }));
        } else {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Произошла ошибка. Попробуйте еще раз.",
              kind: "warning",
              onClick: (function (param) {
                
              })
            }
          });
        }
        Curry._1(setLoading, (function (param) {
          return false;
        }));
      }));
    })
  });
}

const make = FooterForm;

export {
  make,
}
/* Buhta_components__CountryIcon Not a pure module */
